/**
 * @generated SignedSource<<96d50ca3394942921f344d20f560ecdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActivePixCreditCard_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGraphQLType_query">;
  readonly " $fragmentType": "PaymentActivePixCreditCard_query";
};
export type PaymentActivePixCreditCard_query$key = {
  readonly " $data"?: PaymentActivePixCreditCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActivePixCreditCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActivePixCreditCard_query",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useGraphQLType_query",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "graphqlType",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a1f1ed52b88bfcd54e1f093835310766";

export default node;
